<div
  class="box px-2"
  [ngStyle]="{ '--text-temp-color': selected ? '#ffffff' : '#000000' }"
  [cdkContextMenuTriggerFor]="menu"
  (contextmenu)="resetSubmenu()"
>
  <!--  appLongPress (longPress)="baseService.isMobile ? openMenu($event) : null"-->
  <div matRipple class="block" [ngClass]="{ selected: selected, snow_container: crmService.config.is_new_year }">
    <div class="relative">
      <app-avatar
        [size]="baseService.isMobile ? '48px' : '50px'"
        [title]="chat.title"
        [isBlocked]="chat.is_blocked"
        [mediaId]="$safeNavigationMigration(chat.x_data?.photo_id)"
        [chatId]="chat.id"
        [url]="chat.logo_url"
        [isPhotoGallery]="false"
        [additionalUrl]="entityIcons[chat.external_type]"
        [isGroup]="chat.sub_type === CHAT_SUB_TYPES.GROUP"
      />
      @if (chat.assigned_user) {
        <app-avatar
          class="absolute -left-1 -top-1 z-10 h-[22px] w-[22px] rounded-full shadow-sm"
          size="22px"
          [title]="chat.assigned_user.name"
          [url]="chat.assigned_user.avatar_url"
          [isPhotoGallery]="false"
          [matTooltip]="chat.assigned_user.name"
          matTooltipPosition="above"
        />
      }
    </div>

    <div class="info">
      <div class="info-row">
        <div class="title-wrap">
          @if (chat.sub_type === CHAT_SUB_TYPES.GROUP) {
            <app-icon class="icon-xm" svgIcon="groups_fill" />
          }
          @if (chat.x_data?.is_bot) {
            <app-icon class="icon-xm" svgIcon="bot_fill" />
          }
          @if (chat.is_automation_excluded) {
            <app-icon
              class="icon-xm shrink-0 text-amber-600"
              [matTooltip]="'excluded_from_automation' | translate"
              matTooltipPosition="above"
              >block</app-icon
            >
          }
          <span [ngClass]="{ 'mobile-title': baseService.isMobile }" class="title text-truncate">{{ chat.title }}</span>
          @for (channel of chat.channels; track channel.id) {
            <span class="badge text-truncate">{{ channel.name }}</span>
          }
        </div>
        <span class="time">
          @if (chat.updated_at) {
            @if (isToday(chat.updated_at)) {
              <span>{{ chat.updated_at | date: 'HH:mm' }}</span>
            } @else if (isYesterday(chat.updated_at)) {
              <span>{{ 'yesterday' | translate }}</span>
            } @else if (isCurrentWeek(chat.updated_at)) {
              <span>{{ chat.updated_at | date: 'EE' }}</span>
            } @else {
              <span>{{ chat.updated_at | date: 'dd.MM.yy' }}</span>
            }
          }
        </span>
      </div>
      <div class="subtitle">
        <div class="last-text">
          @if (chat.last_message) {
            @if (chat.last_message.sender_type === SENDER_TYPES.SENT) {
              <span class="fw-bold">{{ 'you' | translate }}: </span>
            }
            @if (chat.last_message.sender_type === SENDER_TYPES.SENT_AI) {
              <span class="fw-bold">AI: </span>
            }
            @if (
              chat.sub_type === CHAT_SUB_TYPES.GROUP &&
              chat.last_message.sender_type === SENDER_TYPES.OPPONENT &&
              chat.last_message.sender_name
            ) {
              <span class="fw-bold">{{ chat.last_message.sender_name }}: </span>
            }

            @if (isAttachmentsType) {
              <i class="padding-overflow-italic">{{
                'attachments.' + chat.last_message.type.toLowerCase() | translate
              }}</i>
            } @else if (chat.last_message.type === MESSAGE_TYPES.NO_MESSAGES) {
              <i class="padding-overflow-italic">{{ 'no_messages' | translate }}</i>
            } @else {
              {{ chat.last_message.text }}
            }
          }
        </div>
        <div class="align-self-center">
          @if (!(chat.is_mark_unread || chat.unread_count) && chat.is_pinned) {
            <app-icon class="pin-icon icon-xm" svgIcon="pin" />
          }
          @if (chat.unread_count || chat.is_mark_unread) {
            <div class="unread-count">{{ chat.unread_count || '' }}</div>
          }
        </div>
      </div>
      <app-tags [tags]="chat.tags || []" [selected]="selected" />
    </div>
    @if (baseService.isMobile) {
      <app-button (click)="toggleMobileMenu($event)" btnType="icon">
        <app-icon>more_vert</app-icon>
      </app-button>
    }
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="mobileMenuOrigin"
  [cdkConnectedOverlayOpen]="isMobileMenuOpen"
  [cdkConnectedOverlayPositions]="mobileMenuPositions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="closeMobileMenu()"
  (detach)="closeMobileMenu()"
>
  <div
    class="chat-list-item-context-menu w-80 max-w-[calc(100vw-2rem)] min-w-0 overflow-hidden"
    (click)="$event.stopPropagation()"
    (pointerdown)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    (touchstart)="$event.stopPropagation()"
  >
    @for (item of chatMenus; track $index) {
      @if (item.is_lines) {
        <hr class="context-menu-divider" />
      }
      @if (item.submenu) {
        <button (click)="openSubmenu(item.submenu, $event)" class="context-menu-item clear-line">
          <app-icon class="icon-xxm">{{ item.icon }}</app-icon>
          <span>{{ item.title | translate }}</span>
          <app-icon class="ml-auto icon-xxm">chevron_right</app-icon>
        </button>
      } @else {
        <button
          (click)="runMobileMenuAction(item.action)"
          class="context-menu-item clear-line"
          [class.context-menu-item--danger]="item.is_lines"
        >
          @if (item.is_svg) {
            <app-icon class="icon-xxm" [svgIcon]="item.icon" />
          } @else {
            <app-icon class="icon-xxm">{{ item.icon }}</app-icon>
          }
          <span>{{ item.title | translate }}</span>
        </button>
      }
    }
  </div>
</ng-template>

<ng-template #mobileSubmenu>
  <div
    class="chat-list-item-context-menu w-full"
    (click)="$event.stopPropagation()"
    (pointerdown)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    (touchstart)="$event.stopPropagation()"
  >
    <ng-container *ngTemplateOutlet="submenuContent; context: { $implicit: true }" />
  </div>
</ng-template>

<ng-template #menu>
  <div
    class="chat-list-item-context-menu"
    cdkMenu
    (pointerdown)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    (touchstart)="$event.stopPropagation()"
  >
    @if (!activeSubmenu) {
      @for (item of chatMenus; track $index) {
        @if (item.is_lines) {
          <hr class="context-menu-divider" />
        }
        @if (item.submenu) {
          <button
            (pointerdown)="keepMenuFocus($event)"
            (mousedown)="keepMenuFocus($event)"
            (click)="openSubmenu(item.submenu, $event)"
            class="context-menu-item clear-line"
          >
            <app-icon class="icon-xxm">{{ item.icon }}</app-icon>
            <span>{{ item.title | translate }}</span>
            <app-icon class="ml-auto icon-xxm">chevron_right</app-icon>
          </button>
        } @else {
          <button
            (click)="item.action()"
            class="context-menu-item clear-line"
            [class.context-menu-item--danger]="item.is_lines"
            cdkMenuItem
          >
            @if (item.is_svg) {
              <app-icon class="icon-xxm" [svgIcon]="item.icon" />
            } @else {
              <app-icon class="icon-xxm">{{ item.icon }}</app-icon>
            }
            <span>{{ item.title | translate }}</span>
          </button>
        }
      }
    } @else {
      <ng-container *ngTemplateOutlet="submenuContent; context: { $implicit: false }" />
    }
  </div>
</ng-template>

<ng-template #submenuContent let-isMobile>
  <div class="flex min-w-0 items-center gap-2 px-2 pb-2 pt-1 font-medium text-[rgba(0,0,0,0.87)]">
    <button
      class="flex items-center justify-center bg-transparent p-0 text-[rgba(0,0,0,0.87)]"
      (pointerdown)="keepMenuFocus($event)"
      (mousedown)="keepMenuFocus($event)"
      (click)="isMobile ? closeMobileSubmenu($event) : closeSubmenu($event)"
    >
      <app-icon class="icon-xxm">arrow_back</app-icon>
    </button>
    <span>{{ (activeSubmenu === 'managers' ? 'manager' : 'chat_tags') | translate }}</span>
  </div>

  @if (activeSubmenu === 'managers') {
    @if (isManagersLoading) {
      <div class="flex justify-center p-3 text-[#686c72]"><app-loader /></div>
    } @else {
      <ng-container *ngTemplateOutlet="submenuSearch; context: { $implicit: 'managers' }" />
      <div class="crm-scroll max-h-80 overflow-y-auto">
        @if (!managerSearchTerm.trim()) {
          <button
            class="context-menu-item clear-line w-full min-w-0"
            (pointerdown)="keepMenuFocus($event)"
            (mousedown)="keepMenuFocus($event)"
            (click)="changeManager(null, $event)"
          >
            <app-icon class="icon-xxm">person_off</app-icon>
            <span class="text-truncate min-w-0 flex-1 text-left">{{ 'not_assigned' | translate }}</span>
            @if (isManagerAssigned(null)) {
              <app-icon class="icon-xxm">check</app-icon>
            }
          </button>
        }
        @if (!filteredManagers.length) {
          <span class="flex justify-center p-3 text-[#686c72]">{{ 'nothing_found' | translate }}</span>
        } @else {
          @for (manager of filteredManagers; track manager.id) {
            <button
              class="context-menu-item clear-line w-full min-w-0"
              (pointerdown)="keepMenuFocus($event)"
              (mousedown)="keepMenuFocus($event)"
              (click)="changeManager(manager.id, $event)"
            >
              <app-avatar
                size="20px"
                [title]="manager.name"
                [url]="manager.avatar_url"
                [isPhotoGallery]="false"
              />
              <span class="text-truncate min-w-0 flex-1 text-left">{{ manager.name }}</span>
              @if (isManagerAssigned(manager.id)) {
                <app-icon class="icon-xxm">check</app-icon>
              }
            </button>
          }
        }
      </div>
    }
  } @else {
    @if (isTagsLoading) {
      <div class="flex justify-center p-3 text-[#686c72]"><app-loader /></div>
    } @else if (!tags.length) {
      <span class="flex justify-center p-3 text-[#686c72]">{{ 'no_tags' | translate }}</span>
    } @else {
      <ng-container *ngTemplateOutlet="submenuSearch; context: { $implicit: 'tags' }" />
      @if (!filteredTags.length) {
        <span class="flex justify-center p-3 text-[#686c72]">{{ 'nothing_found' | translate }}</span>
      } @else {
        <div class="crm-scroll max-h-80 overflow-y-auto">
          @for (tag of filteredTags; track tag.id) {
            <button
              class="context-menu-item clear-line w-full min-w-0"
              (pointerdown)="keepMenuFocus($event)"
              (mousedown)="keepMenuFocus($event)"
              (click)="toggleTag(tag.id, $event)"
            >
              <span class="h-4 w-4 shrink-0 rounded-full" [style.background-color]="tag.color"></span>
              <span class="text-truncate min-w-0 flex-1 text-left">{{ tag.name }}</span>
              @if (isTagUpdating(tag.id)) {
                <app-loader class="flex h-6 w-6" size="tiny" strokeWidth="3" />
              } @else if (isTagAssigned(tag.id)) {
                <app-icon class="icon-xxm">check</app-icon>
              }
            </button>
          }
        </div>
      }
    }
  }
</ng-template>

<ng-template #submenuSearch let-type>
  <div
    class="mx-1 mb-1 mt-0.5 grid w-auto min-w-0 grid-cols-[auto_minmax(0,1fr)] items-center gap-2 rounded-lg border border-slate-200 bg-white/80 px-3 py-2 text-slate-500"
  >
    <span class="flex shrink-0 items-center justify-center leading-none"
      ><app-icon class="!h-5 !w-5 !min-w-5 !text-[20px] !leading-5" [isFlexBox]="false">search</app-icon></span
    >
    @if (type === 'managers') {
      <input
        class="min-w-0 w-full border-0 bg-transparent text-base leading-normal text-slate-800 outline-none placeholder:text-slate-400"
        type="search"
        autocomplete="off"
        [(ngModel)]="managerSearchTerm"
        [placeholder]="'search' | translate"
      />
    } @else {
      <input
        class="min-w-0 w-full border-0 bg-transparent text-base leading-normal text-slate-800 outline-none placeholder:text-slate-400"
        type="search"
        autocomplete="off"
        [(ngModel)]="tagSearchTerm"
        [placeholder]="'search' | translate"
      />
    }
  </div>
</ng-template>
